import { useState, Fragment } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Badge } from "reactstrap";
import { BiTimeFive } from "react-icons/bi";
import { BsCalendarDate, BsMusicNoteList } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Play } from "react-feather";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction.js";
import ReactPaginate from "react-paginate";

const API = process.env.REACT_APP_MICRO_PLANING_URL;

const EpisodesCards = ({ episodesByTag, setCurrentPage, EpisodeLastPage }) => {
  const [activeView, setActiveView] = useState("list");
  const { t } = useTranslation();
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  const dispatch = useDispatch();
  // ** Vars
  const formatDate = (date) => {
    let intitalDate = new Date(date);
    return (
      <>
        <BsCalendarDate style={{ margin: "5px" }} />
        {`${intitalDate.getDay()}/${
          intitalDate.getMonth() + 1
        }/${intitalDate.getFullYear()}`}{" "}
      </>
    );
  };

  const formatTime = (date) => {
    let intitalDate = new Date(date);
    return (
      <>
        <BiTimeFive style={{ margin: "5px" }} />{" "}
        {`${intitalDate.getHours()}:${intitalDate.getMinutes()}:${intitalDate.getSeconds()}`}
      </>
    );
  };

  return (
    <div>
      <div className="blog_category_wrapper blog_single_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "80%" }}>
          <div className="row">
            <div className="col-md-12 d-none d-sm-none d-md-block d-lg-block">
              <div className="filter-area ms_cover">
                <div className="list-grid">
                  <ul className="nav nav-tabs">
                    <li
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      className="nav-item"
                    >
                      <a
                        className="nav-link"
                        data-bs-toggle="tab"
                        onClick={() => setActiveView("grid")}
                      >
                        <i className="fas fa-th-large" />
                      </a>
                    </li>
                    <li
                      className="nav-item"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <a
                        className="nav-link active"
                        data-bs-toggle="tab"
                        onClick={() => setActiveView("list")}
                      >
                        <i className="fas fa-list-ul" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {episodesByTag?.length ? (
              <Fragment>
                <div className="col-md-22">
                  <div className="tab-content btc_shop_index_content_tabs_main jb_cover">
                    <div id={activeView} className="tab-pane active">
                      <div className="row">
                        {episodesByTag?.map((item, i) => {
                          return (
                            <div
                              key={i}
                              style={{ minWidth: "270px", maxHeight: "600px" }}
                              className={
                                activeView === "list"
                                  ? "col-lg-32 col-md-12 col-sm-12 col-12"
                                  : "col-xl-4 col-lg-4 col-md-4 col-sm-12"
                              }
                            >
                              <div
                                className={
                                  activeView === "list"
                                    ? "featured_artist_list shop_video_wrapper shop_list_img_wrapper ms_cover"
                                    : "featured_artist_list shop_video_wrapper  ms_cover"
                                }
                              >
                                <img
                                  height="210px"
                                  className="img-responsive"
                                  src={item.emission.picture}
                                  alt={item.id}
                                />

                                <div style={{ margin: "15px" }}>
                                  <p
                                    style={{
                                      margin: "2px",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    <a> Episode: {item.name}</a>
                                  </p>
                                  <p
                                    style={{ margin: "2px" }}
                                    className="various_artist_text"
                                  >
                                    <a>
                                      {t("Emission")}: {item.emission.name}
                                    </a>
                                  </p>
                                  <p
                                    style={{ margin: "2px" }}
                                    className="various_artist_text"
                                  >
                                    <a>{formatDate(item.created_at)}</a>
                                  </p>
                                  <p
                                    style={{ margin: "2px" }}
                                    className="various_artist_text"
                                  >
                                    <a>{formatTime(item.created_at)}</a>
                                  </p>

                                  <p
                                    className="various_artist_text"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "flex-start",
                                      flexWrap: "wrap",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <span>
                                      {" "}
                                      <a>{t("animator")}:</a>{" "}
                                      <Badge
                                        style={{ margin: "2px" }}
                                        color="light-info"
                                      >
                                        {item?.animator?.first_name +
                                          " " +
                                          item?.animator?.last_name}
                                      </Badge>
                                    </span>
                                  </p>

                                  {item?.categories.length ? (
                                    <p
                                      className="various_artist_text"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                        flexWrap: "wrap",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <span>
                                        {" "}
                                        <a>categorys:</a>{" "}
                                        {item.categories.map((ele) => (
                                          <Link
                                            to={`/episode/category/${ele.slug}`}
                                          >
                                            {" "}
                                            <Badge
                                              style={{ margin: "2px" }}
                                              color="light-warning"
                                            >
                                              {ele.name}
                                            </Badge>
                                          </Link>
                                        ))}
                                      </span>
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  {item?.tags.length ? (
                                    <p
                                      className="various_artist_text"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                        flexWrap: "wrap",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <span>
                                        {" "}
                                        <a>_____tags:</a>{" "}
                                        {item.tags.map((ele) => (
                                          <Link to={`/episode/tag/${ele.slug}`}>
                                            {" "}
                                            <Badge
                                              style={{ margin: "2px" }}
                                              color="light-secondary"
                                            >
                                              #{ele.name}
                                            </Badge>
                                          </Link>
                                        ))}
                                      </span>
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                  {item?.columnist.length ? (
                                    <p
                                      className="various_artist_text"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                        flexWrap: "wrap",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <span>
                                        {" "}
                                        <a>{t("columnist")}:</a>{" "}
                                        {item.columnist.map((ele) => (
                                          <Badge
                                            style={{ margin: "2px" }}
                                            color="light-primary"
                                          >
                                            {ele.first_name +
                                              " " +
                                              ele.last_name}
                                          </Badge>
                                        ))}
                                      </span>
                                    </p>
                                  ) : (
                                    ""
                                  )}

                                  <div className="item-wrapper episode">
                                    {item.status_id == 3 ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          alignItems: "center",
                                          marginTop: "10px",
                                          justifyContent: "space-around",
                                        }}
                                      >
                                        {PlayerFrontOfficeReducer?.currentSong ===
                                        item.podcast?.file_path ? (
                                          <div>
                                            {<BsMusicNoteList size={20} />}
                                            {t("playing")}
                                          </div>
                                        ) : (
                                          <div
                                            onClick={() =>
                                              dispatch(
                                                addMusic({
                                                  currentsong:
                                                    item.podcast?.file_path,
                                                  download: `${API}/podcast/download/${item.id}`,
                                                  namesong: `${item.podcastname}`,
                                                  is_web_rtc: false,
                                                  has_video:
                                                    item.podcastname.endsWith(
                                                      "mp4"
                                                    ) && true,
                                                })
                                              )
                                            }
                                          >
                                            <Play
                                              size={20}
                                              className="pointer_cursor "
                                              id="Play"
                                              color="#A8ECE7"
                                            />
                                            {t("poadcast")} :
                                          </div>
                                        )}

                                        <Badge
                                          className="text-capitalize"
                                          style={{
                                            width: "150px",
                                            marginLeft: "5px",
                                          }}
                                          color="light-danger"
                                          pill
                                        >
                                          {t("finished")}
                                        </Badge>
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          alignItems: "center",
                                          marginTop: "10px",
                                          justifyContent: "space-around",
                                        }}
                                      >
                                        <Badge
                                          className="text-capitalize"
                                          style={{ width: "80px" }}
                                          color="light-success"
                                          pill
                                        >
                                          {t("comming")}
                                        </Badge>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Pagination */}
                <div className="blog_pagination_section ms_cover">
                  <ReactPaginate
                    previousLabel={
                      <p className="prev">
                        <i className="flaticon-left-arrow" />
                      </p>
                    }
                    nextLabel={
                      <p className="next">
                        <i className="flaticon-right-arrow" />
                      </p>
                    }
                    pageCount={EpisodeLastPage}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={2}
                    breakLabel="..."
                    activeClassName="third_pagger"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    onPageChange={(page) => {
                      setCurrentPage(page.selected + 1);
                    }}
                    pageClassName={"page-item"}
                    containerClassName={
                      "pagination react-paginate justify-content-end p-1"
                    }
                  />
                </div>
              </Fragment>
            ) : (
              <div className="d-flex justify-content-center mt-2">
                <p>{t("No Results")}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EpisodesCards;
